module.exports = __webpack_public_path__ + "static/media/vrbo-badge.e7a0c562.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vrbo-badge.svg
// module id = 464
// module chunks = 0